import axios from 'axios';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import ReactPaginate from 'react-paginate'
import $ from 'jquery';
import React, { Component, useState } from 'react';
import Cookies from 'universal-cookie';
import "../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../services/ApiRest';
import { Alert } from 'bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as xlsx from "xlsx";

const cookie = new Cookies();
const urlListarPeriodos = ApiUrl + "periodos-creditos-extra-docente" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarCreditosDoc = ApiUrl + "docente-creditosext-periodo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarEstudiantesCreditos = ApiUrl + "estudiantes-creditosext-periodo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlActualizarCredito = ApiUrl + "estudiante-creditos-extra";
const UrlIngresarCalificacionesCredito = ApiUrl + "ingresar-calificaciones-estcred?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

const api_key = "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"
const itemsPerPage = 3;

export default class ListarCreditosDocente extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ListCreditos: [],
            ListEstudiantes: [],
            currentItems: [],
            ListEstudiantesExcel: [],
            listaperiodos: [],
            periodo: 1,
            itemOffset: 0,
            pageCount: 0,
            showResults: "none",
            rolDocenteSeleccionado: "",
            modalModificar: false,
            form: {},
        }
    }

    componentDidMount() {
        axios.get(urlListarPeriodos, {
            params: {
                idDocente: cookie.get("idAdministrativo"),
            }
        }).then(response => {
            this.setState({ listaperiodos: response.data.data });
        });
    }

    handlePeriodoChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios.get(`${urlListarCreditosDoc}&administrativo_id=${cookie.get("idAdministrativo")}&periodo_academico_id=${this.state.periodo}`)
            .then(response => {
                this.setState({ ListCreditos: response.data });
            });
    }

    seleccionarCredito = () => {
        let id_credito_extra = 0;
        let id_paralelo = 0;

        this.setState({ showResults: "block" });

        $(".afiliado:checked").each(function () {
            const fila = $(this).closest("tr");
            id_credito_extra = fila.find("td").eq(0).html();
            id_paralelo = fila.find("td").eq(1).html();
        });

        axios.get(`${urlListarEstudiantesCreditos}&idCreditoExtra=${id_credito_extra}&idParalelo=${id_paralelo}&idPeriodo=${this.state.periodo}`)
            .then(response => {
                const lista = response.data;
                const itemOffset = 0;
                const endOffset = itemOffset + itemsPerPage;
                this.setState({
                    ListEstudiantesExcel: lista,
                    currentItems: lista.slice(itemOffset, endOffset),
                    pageCount: Math.ceil(lista.length / itemsPerPage),
                    itemOffset: itemOffset
                });
            });
    }

    mostrarModalModificar = (credito = null) => {
        if (credito) {
            const p1 = Number(credito.parcial1) || 0;
            const p2 = Number(credito.parcial2) || 0;
            const p3 = Number(credito.parcial3) || 0;
            const ef = Number(credito.examen_final) || 0;
            const es = Number(credito.examen_suspension) || 0;

            const promedioParciales = this.promedioparciales(p1, p2, p3);
            const promedioFinal = this.promediototal(p1, p2, p3, ef, es);
            const estadoTexto = promedioFinal < 7 ? "REPROBADO" : "APROBADO";
            const equivalencia = promedioFinal < 7 ? 0 : 1;

            this.setState({
                modalModificar: true,
                form: {
                    id: credito.id || "",
                    parcial1: p1,
                    parcial2: p2,
                    parcial3: p3,
                    examen_final: ef,
                    examen_suspension: es,
                    equivalencia: equivalencia,
                    asistencia: Number(credito.asistencia) || 0,
                    creditos_extra_id: credito.creditos_extra_id || "",
                    id_paralelo: credito.id_paralelo || "",
                    id_periodo_academico: credito.id_periodo_academico || "",

                    // 👇 AÑADIDOS para que el modal muestre nombre y descripción
                    estudiante: credito.estudiante || {},
                    credito_extra: credito.credito_extra || {}
                    // (si tu API usa otro nombre, ej. creditos_extra, cámbialo aquí)
                },
                proma: promedioParciales,
                promf: promedioFinal,
                equivalencia: estadoTexto
            }, () => {
                $("#proma").val(promedioParciales);
                $("#promf").val(promedioFinal);
                $("#equivalencia").val(estadoTexto);
            });

        } else {
            this.setState({
                modalModificar: true,
                form: {
                    id: "",
                    parcial1: 0,
                    parcial2: 0,
                    parcial3: 0,
                    examen_final: 0,
                    examen_suspension: 0,
                    equivalencia: false,
                    asistencia: 0,
                    creditos_extra_id: "",
                    id_paralelo: "",
                    id_periodo_academico: "",

                    // 👇 Vacíos para evitar undefined en el modal
                    estudiante: {},
                    credito_extra: {}
                },
                proma: "",
                promf: "",
                equivalencia: ""
            }, () => {
                $("#proma").val("");
                $("#promf").val("");
                $("#equivalencia").val("");
            });
        }
    };

    ocultarModalModificar = () => {
        this.setState({ modalModificar: false });
    }

    handleChange = async (e) => {
        await this.setState({ form: { ...this.state.form, [e.target.name]: e.target.value } });
    }

    ActualizarCreditoEstudiante = async () => {
        const { form, estudianteSeleccionado, periodoSeleccionado } = this.state;

        if (!form?.id) {
            // usa tu forma de alertar (swal, toast, etc.)
            console.warn("Falta el ID del registro a actualizar");
            return;
        }

        // Id del estudiante: prioriza el que viene en el form (anidado) y si no, el seleccionado
        const id_estudiante =
            form?.estudiante?.id_estudiante ??
            form?.id_estudiante ??
            estudianteSeleccionado ??
            null;

        // Construimos SOLO los campos que tu backend espera
        const payload = {
            id_estudiante: id_estudiante ?? undefined,
            id_paralelo: form?.id_paralelo,
            id_periodo_academico: periodoSeleccionado ?? form?.id_periodo_academico,
            parcial1: form?.parcial1,
            parcial2: form?.parcial2,
            parcial3: form?.parcial3,
            examen_final: form?.examen_final,
            examen_suspension: form?.examen_suspension,
            equivalencia: form?.equivalencia,   // backend: nullable|boolean
            asistencia: form?.asistencia,
        };

        // Quita claves undefined para respetar "sometimes"
        Object.keys(payload).forEach((k) => payload[k] === undefined && delete payload[k]);

        try {
            await axios.put(`${UrlActualizarCredito}/${form.id}${api_key}`, payload);
            // cierra el modal (usa el tuyo: ocultarModal u ocultarModalModificar)
            this.ocultarModalModificar?.() ?? this.ocultarModal?.();
            // refresca la lista
            this.seleccionarCredito();
        } catch (err) {
            // Manejo rápido de validación 422 o errores generales
            const msg = err?.response?.data?.message || "No se pudo actualizar.";
            console.error(msg, err?.response?.data);
            // swal({ text: msg, icon: "error" });
        }
    };

    handlePageClick = (event) => {
        const { ListEstudiantesExcel } = this.state;
        const newOffset = (event.selected * itemsPerPage) % ListEstudiantesExcel.length;
        const endOffset = newOffset + itemsPerPage;
        this.setState({
            itemOffset: newOffset,
            currentItems: ListEstudiantesExcel.slice(newOffset, endOffset),
            pageCount: Math.ceil(ListEstudiantesExcel.length / itemsPerPage)
        });
    }

    promedioparciales = (p1, p2, p3) => {
        var promp = (p1 + p2 + p3) / 3;
        var promp = (promp * 6) / 10;
        return (promp.toFixed(2))
    }

    promediosobre4 = (p10) => {
        var prom4 = (p10 * 4) / 10;
        return (prom4.toFixed(2))
    }

    promediototal = (p1, p2, p3, ef, es) => {
        var promp = (p1 + p2 + p3) / 3;
        var promp = (promp * 6) / 10;
        var examfinal = (ef * 4) / 10;
        var promacumulado = promp + examfinal;
        //var promfinal = promacumulado >= 7 ? promacumulado : (promacumulado + es) / 2;
        var promfinal = 0.00;
        if (promacumulado >= 7) {
            promfinal = promacumulado;
        }
        else {

            if (((promacumulado >= 4) && (promacumulado < 7)) && (es == 0)) {
                promfinal = promacumulado;
            }
            else {
                if (((promacumulado >= 4) && (promacumulado < 7)) && (es > 0)) {

                    promfinal = (promacumulado + es) / 2;
                }
                else {
                    promfinal = promacumulado;
                }
            }
        }
        return (promfinal.toFixed(2))
    }

    actualizarValoresModal = async (e) => {
        const { name, type, checked, value } = e.target;

        await this.setState({
            [name]: type === 'checkbox' ? checked : value,
            form: {
                ...this.state.form,
                [name]: type === 'checkbox' ? checked : value
            }
        });

        // Cálculo de promedios
        const { parcial1, parcial2, parcial3, examen_final, examen_suspension } = this.state.form;
        const promparciales = this.promedioparciales(Number(parcial1), Number(parcial2), Number(parcial3));
        const promfinal = this.promediototal(Number(parcial1), Number(parcial2), Number(parcial3), Number(examen_final), Number(examen_suspension));

        // Determinar equivalencia como entero
        const equivalenciaInt = promfinal < 7 ? 0 : 1;
        const equivalenciaTexto = promfinal < 7 ? "REPROBADO" : "APROBADO";

        // Actualiza el form con equivalencia como entero
        this.setState({
            form: {
                ...this.state.form,
                equivalencia: equivalenciaInt
            },
            proma: promparciales,
            promf: promfinal,
            equivalencia: equivalenciaTexto // solo para mostrar en la interfaz
        });

        // Actualiza los campos visibles en el modal
        $("#proma").val(promparciales);
        $("#promf").val(promfinal);
        $("#equivalencia").val(equivalenciaTexto);
    };

    convertirDosDecimales = (nota, fallback = '0.00') => {
        if (nota === null || nota === undefined || nota === '') return fallback;
        const n = (typeof nota === 'number')
            ? nota
            : Number(String(nota).replace(',', '.'));
        return Number.isFinite(n) ? n.toFixed(2) : fallback;
    }

    readUploadFile = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        //e.preventDefault();
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            }
        };
        if (e.target.files) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = xlsx.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);
                console.log(json);
                axios.post(UrlIngresarCalificacionesCredito, {
                    calificaciones: json,
                }, axiosConfig)
                    .then(response => {
                        if (response.data.success === true) {
                            swal({
                                text: "Datos procesados correctamente",
                                icon: "success",
                                button: "Aceptar",
                            });
                            this.seleccionarCredito();
                        } else {
                            swal({
                                text: "No se actualizó los datos",
                                icon: "error",
                                button: "Aceptar",
                            });
                        }
                    })
                    .catch(error => {
                        this.setState({ error: "No existe conexión con el servidor" });
                        swal({
                            text: "No existe conexión con el servidor",
                            icon: "error",
                            button: "Aceptar",

                        });
                    });
            };
            reader.readAsArrayBuffer(e.target.files[0]);
            $(function () {
                $("#upload").val('');
            });
        }
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas d-flex align-items-center">
                        <i className="far fa-sticky-note me-2"></i>
                        <b>Créditos Extra Asignados</b>
                    </div>

                    <div className="p-3 rounded-3">
                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label text-azul small">Periodo Académico</label>
                                <select
                                    name="periodo"
                                    className="form-select form-select-sm"
                                    value={this.state.periodo}
                                    onChange={this.handlePeriodoChange}
                                >
                                    <option>Seleccione el período</option>
                                    {this.state.listaperiodos.map(p => (
                                        <option key={p.id_periodo_academico} value={p.id_periodo_academico}>{p.descripcion_periodo_academico}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <h6 className="fw-bold text-center mb-3 text-azul small">CRÉDITOS DEL DOCENTE</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-hover align-middle small">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-azul">ID</th>
                                        <th className="text-azul">Crédito</th>
                                        <th className="text-azul">Paralelo</th>
                                        <th className="text-azul">Fecha Inicio</th>
                                        <th className="text-azul">Fecha Fin</th>
                                        <th className="text-azul">Seleccionar</th>
                                    </tr>
                                </thead>
                                <tbody className="text-azul">
                                    {this.state.ListCreditos.map(c => (
                                        <tr key={c.id}>
                                            <td hidden>{c.credito_extra.id}</td>
                                            <td hidden>{c.paralelo.id_paralelo}</td>
                                            <td>{c.id}</td>
                                            <td>{c.credito_extra.descripcion}</td>
                                            <td>{c.paralelo.nombre_paralelo}</td>
                                            <td>{c.fecha_inicio}</td>
                                            <td>{c.fecha_fin}</td>
                                            <td>
                                                <input
                                                    type="radio"
                                                    name="afiliado"
                                                    className="form-check-input afiliado"
                                                    onChange={this.seleccionarCredito}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Estudiantes */}
                    <div className="row" style={{ display: this.state.showResults }}>
                        <div className="col-12">
                            <h6 className="fw-bold text-center my-3 text-azul small">LISTA DE ESTUDIANTES</h6>
                            <div className="table-responsive">
                                <table className="table table-sm table-hover align-middle small">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-azul">Estudiante</th>
                                            <th>P1</th>
                                            <th>P2</th>
                                            <th>P3</th>
                                            <th>Promedio Parcial/6</th>
                                            <th>Final/4</th>
                                            <th>Suspensión</th>
                                            <th>Promedio Final/10</th>
                                            <th>Estado</th>
                                            <th>Asistencia</th>
                                            <th className="text-azul">Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-azul">
                                        {this.state.currentItems.map(c => (
                                            <tr key={c.id}>
                                                <td>{`${c.estudiante.primer_apellido_estudiante} ${c.estudiante.segundo_apellido_estudiante} ${c.estudiante.primer_nombre_estudiante} ${c.estudiante.segundo_nombre_estudiante}`}</td>
                                                <td>{c.parcial1}</td>
                                                <td>{c.parcial2}</td>
                                                <td>{c.parcial3}</td>
                                                <td>{this.promedioparciales(Number(c.parcial1), Number(c.parcial2), Number(c.parcial3))}</td>
                                                <td>{this.promediosobre4(c.examen_final)}</td>
                                                <td>{c.examen_suspension}</td>
                                                <td>{this.promediototal(Number(c.parcial1), Number(c.parcial2), Number(c.parcial3), Number(c.examen_final), Number(c.examen_suspension))}</td>
                                                <td>{c.equivalencia === 1 ? "Aprobado" : "Reprobado"}</td>
                                                <td>{c.asistencia}</td>
                                                <td>
                                                    <button className="btn btn-sm btn-primary" onClick={() => this.mostrarModalModificar(c)}>
                                                        <i className="fa fa-edit"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <table id="tablaasignaturasexcel" className="table text-left" hidden>
                                    <thead >
                                        <tr>
                                            <th scope="col">ID</th>
                                            <th scope="col">ESTUDIANTE</th>
                                            <th scope="col">P1</th>
                                            <th scope="col">P2</th>
                                            <th scope="col">P3</th>
                                            <th scope="col">PROMEDIO_PARCIAL_6</th>
                                            <th scope="col">EXAMEN_FINAL_10</th>
                                            <th scope="col">SUSPENSION_10</th>
                                            <th scope="col">PROMEDIO FINAL / 10</th>
                                            <th scope="col">ESTADO</th>
                                            <th scope="col">ASISTENCIA</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.ListEstudiantesExcel.map(consola => (
                                            <tr key={consola.id_matricula_asignatura}>
                                                <td class="mes">{consola.id}</td>
                                                <td class="mes">{consola.estudiante.primer_apellido_estudiante + " " + consola.estudiante.segundo_apellido_estudiante + " " + consola.estudiante.primer_nombre_estudiante + " " + consola.estudiante.segundo_nombre_estudiante}</td>
                                                <td class="mes">{this.convertirDosDecimales(consola.parcial1)}</td>
                                                <td class="mes">{this.convertirDosDecimales(consola.parcial2)}</td>
                                                <td class="mes">{this.convertirDosDecimales(consola.parcial3)}</td>
                                                <td class="mes">{this.promedioparciales(Number(consola.parcial1), Number(consola.parcial2), Number(consola.parcial3))}</td>
                                                <td class="mes">{consola.examen_final}</td>
                                                <td class="mes">{consola.examen_suspension}</td>
                                                <td class="mes">{this.promediototal(Number(consola.parcial1), Number(consola.parcial2), Number(consola.parcial3), Number(consola.examen_final), Number(consola.examen_suspension))}</td>
                                                <td class="mes">{consola.equivalencia == 0 ? "REPROBADO" : "APROBADO"}</td>
                                                <td class="mes">{consola.asistencia}</td>
                                                <td class="detalle">
                                                    <button onClick={() => this.mostrarModalModCalificacionEst(consola)} > <i className=" fas fa-clipboard-list" ></i></button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div className="d-flex justify-content-center mt-1">
                                    <ReactPaginate
                                        previousLabel="<"
                                        nextLabel=">"
                                        pageCount={this.state.pageCount}
                                        onPageChange={this.handlePageClick}
                                        containerClassName="pagination pagination-sm-custom"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        activeClassName="active"
                                    />
                                </div>
                            </div>

                            <div className="row g-3 my-2 text-center">
                                <div className="col-12 col-md-6">
                                    <ReactHTMLTableToExcel
                                        id="botonExportarExcel"
                                        className="btn btn-sm btn-success"
                                        table="tablaasignaturasexcel"
                                        filename="matrizcalificacionesexcel"
                                        sheet="pagina 1"
                                        buttonText="Descargar Plantilla"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <input
                                        type="file"
                                        id="upload"
                                        className="form-control form-control-sm"
                                        onChange={this.readUploadFile}
                                    />
                                </div>
                            </div>

                            <Modal isOpen={this.state.modalModificar}>
                                <ModalHeader>Modificar Información</ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <label className="form-label">Estudiante</label><br />
                                        <input type="text" id="nombres_estudiante" name="primer_nombre_estudiante" value={[
                                            this.state.form?.estudiante?.primer_apellido_estudiante,
                                            this.state.form?.estudiante?.segundo_apellido_estudiante,
                                            this.state.form?.estudiante?.primer_nombre_estudiante,
                                            this.state.form?.estudiante?.segundo_nombre_estudiante
                                        ].filter(Boolean).join(" ")} className="form-control" placeholder="" autocomplete="off" readOnly />
                                        <label className="form-label">Crédito Extra</label><br />
                                        <input type="text" id="credito" name="credito" value={this.state.form?.credito_extra?.descripcion} className="form-control" placeholder="" autocomplete="off" readOnly />
                                        <label className="form-label">Parcial 1</label><br />
                                        <input type="text" id="parcial1" name="parcial1" value={this.state.form.parcial1} onChange={this.actualizarValoresModal} className="form-control" placeholder="" autocomplete="off" required />
                                        <label className="form-label">Parcial 2</label><br />
                                        <input type="text" id="parcial2" name="parcial2" value={this.state.form.parcial2} onChange={this.actualizarValoresModal} className="form-control" placeholder="" autocomplete="off" required />
                                        <label className="form-label">Parcial 3</label><br />
                                        <input type="text" id="parcial3" name="parcial3" value={this.state.form.parcial3} onChange={this.actualizarValoresModal} className="form-control" placeholder="" autocomplete="off" required />
                                        <label className="form-label">Promedio Acumulado</label>
                                        <input type="text" id="proma" name="proma" value={this.state.proma} className="form-control" placeholder="" autocomplete="off" required disabled />
                                        <label>Examen Final</label>
                                        <input type="text" name="examen_final" className="form-control" value={this.state.form.examen_final} onChange={this.actualizarValoresModal} />
                                        <label>Examen Suspensión</label>
                                        <input type="text" name="examen_suspension" className="form-control" onChange={this.actualizarValoresModal} />
                                        <label className="form-label">Promedio Final</label><br />
                                        <input type="text" id="promf" name="promf" value={this.state.promf} onChange={this.actualizarValoresModal} className="form-control" placeholder="" autocomplete="off" required disabled />
                                        <label className="form-label">Estado</label><br />
                                        <input type="text" id="equivalencia" name="equivalencia" value={this.state.equivalencia} className="form-control" placeholder="" autocomplete="off" required disabled />
                                        <label>Asistencia</label>
                                        <input type="text" name="asistencia" className="form-control" value={this.state.form.asistencia} onChange={this.handleChange} />
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                    <button className="btn btn-primary" onClick={this.ActualizarCreditoEstudiante}>Guardar</button>
                                    <button className="btn btn-secondary" onClick={this.ocultarModalModificar}>Cancelar</button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}